<!--
2022-09-22 Matt Promotion改版
2022-10-03 HHY 增加promotion中all\free cash\deposit等列表中图片展示排序
-->
<template>
  <div class="promotionPage">
    <div class="nav-wrapper"  :style="[
       swiper && swiper.isBeginning===true ? { 'padding-left': '1.5vw' } : {},
       swiper && !swiper.isEnd===true ? { 'padding-right': '8vw' } : {}
     ]">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(barItem,index) in topBarList" :key="index">
          <div class="redDot" v-if="index !==0 && index!==2 && isShowRedDot()"></div>
          <div class="nav">
            <div class="nav-item" :class="{active: topBarActive ===barItem}" @click="chooseBarItem(index)">
              <span>{{ $t("lang.promotion.topBarList")[barItem] }}</span>
            </div>
          </div>
<!--          <div class="indicator" v-if="topBarActive ===barItem"></div>-->
        </div>
      </div>
      <div class="arrow swiper-button-prev" v-show="swiper && !swiper.isBeginning" @click="prev">
        <img :src="goPrev" alt="">
      </div>
      <div class="arrow swiper-button-next" v-show="swiper && !swiper.isEnd" @click="next">
        <img :src="goNext" alt="">
      </div>
    </div>
    <div class="promotionsBox">
      <div :class="lang==='IN' ? 'leftBarIN' : 'leftBar'">
        <div @click="chooseNavItem(navItem, index)" :class="barActive === index?'itemed':'item'"   v-for="(navItem,index) in navItems" :key="index">
          {{ $t("lang.promotion." + navItem) }}</div>
      </div>
      <div class="promotions">
        <div class="noContent" v-if="filterPromotionList.length === 0">{{$t("lang.promotion.noContent")}}</div>
        <div class="promotionImage" :key="promotion.name"
             @click="gotoRoute(promotion.path, promotion.key,promotion.type,promotion.id)"
             v-for="promotion in filterPromotionList">
          <div class="isHot" v-if="promotion.IsHot">Hot</div>
          <div class="isRedDot" v-if="promotion.RedDot"></div>
          <div class="BeginTime" v-if="promotion.ShowTimeSpan">
            <img src="../../assets/images/promotion/clock.png" alt="" class="clock">
            <div class="time">{{formatDateTime(promotion.BeginTime) + ' —— ' + formatDateTime(promotion.ExpirationTime)}}</div>
          </div>
          <img
            class="introduceImg"
            :alt="promotion.name"
            :src="promotion.introduceImg"
          >
        </div>
      </div>
    </div>

    <IFrame3Part
      :iFrameSrc="iFrameSrc"
      :handelClose="() => handleCloseIFrame3Part()"
      v-if="showTournament"
    >
    </IFrame3Part>
  </div>
</template>

<script>
import Swiper from 'swiper'
import request from '@/service'
import IFrame3Part from '@/components/IFrame3Part/index'
import goPrev from '@/assets/images/home/goPrev.svg'
import goNext from '@/assets/images/home/goNext.svg'
import {LogUtils} from '../../utils'

export default {
  name: 'Promotion',
  data () {
    return {
      lang: localStorage.getItem('locale'),
      barActive: 0,
      goPrev,
      goNext,
      swiper: null,
      swiperIndex: 0,
      userInfo: null,
      promotionList: [],
      filterPromotionList: [],
      iFrameSrc: '',
      navItems: [],
      topBarList: [0, 1, 2],
      topBarActive: 0,
      currentNavItem: this.navItems ? this.navItems[0] : null,
      showTournament: false
    }
  },
  components: {
    IFrame3Part
  },
  watch: {
    '$store.state.locale': function () {
      this.barActive = 0
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    formatDateTime (input) {
      // 方法一：字符串直接切割（推荐）
      const [datePart, timePart] = input.split('T')
      const formattedTime = timePart.slice(0, 5)
      return `${datePart} ${formattedTime}`
    },
    getTop () {
      if (this.barActive === 0) {
        return 3 + '%'
      } else if (this.barActive === 1) {
        return 11.2 + '%'
      } else if (this.barActive === 2) {
        return 19.5 + '%'
      } else if (this.barActive === 3) {
        return 27.8 + '%'
      } else if (this.barActive === 4) {
        return 36 + '%'
      } else if (this.barActive === 5) {
        return 44.4 + '%'
      } else if (this.barActive === 6) {
        return 52.6 + '%'
      } else if (this.barActive === 7) {
        return 61 + '%'
      } else if (this.barActive === 8) {
        return 69.2 + '%'
      }
    },
    prev () {
      this.swiper.slidePrev()
    },
    next () {
      this.swiper.slideNext()
    },
    isShowRedDot () {
      let isShow = false
      this.filterPromotionList.forEach(item => {
        if (item.RedDot) {
          isShow = true
        }
      })
      return isShow
    },
    chooseBarItem (index) {
      this.topBarActive = index
      this.chooseNavItem(this.currentNavItem, this.barActive)
    },
    chooseNavItem: function (currentNavItem, index, isInit) {
      if (index || index === 0) {
        this.barActive = index
      }
      this.currentNavItem = currentNavItem
      // 滚动条回到顶部
      document.querySelector('.promotions').scrollTop = 0
      this.filterPromotionList = this.promotionList.concat() // 赋值数组（非引用）；在‘ALL’里为默认排序，即，startUpPopup json里按照代码先后顺序物理排序 2022-10-03 HHY
      if (localStorage.getItem('cid') && this.$store.state.watchedCid.includes(localStorage.getItem('cid'))) {
        this.filterPromotionList = this.filterPromotionList.filter((e) => {
          return e.key.toLowerCase().indexOf('check in') === -1
        })
      }
      // 统一处理所有情况（包括 currentNavItem === 'All'）
      this.filterPromotionList = this.filterPromotionList.filter(i => {
        // 条件1：如果 currentNavItem 不是 'All'，需校验分类匹配
        if (currentNavItem !== 'All' && !i.category.includes(currentNavItem)) {
          return false
        }

        // 条件2：根据 topBarActive 校验附加属性
        switch (this.topBarActive) {
          case 1:
            return i.RedDot === true // 仅保留 RedDot 为 true
          case 2:
            return i.IsHot === true // 仅保留 IsHot 为 true
          default: // 0 或其他情况不校验
            return true
        }
      })
      this.filterPromotionList.sort((a, b) => {
        let n1 = a.startUpPopup
        let n2 = b.startUpPopup
        n1 = (n1 === null || n1 === undefined) ? -1 : n1 // 防止startUpPopup json中未设置orderInCategory或orderInCategory中未正确设置排序值
        n2 = (n2 === null || n2 === undefined) ? -1 : n2
        return n1 - n2 // a - b 从小到大排序
      })
      if (this.swiper) {
        const current = this.navItems.findIndex(item => item === currentNavItem)
        if (current > 1) {
          this.swiper.slideTo(current - 1)
        } else {
          this.swiper.slideTo(0)
        }
      }
      if (this.isShowRedDot() && isInit) {
        this.chooseBarItem(1)
      }
    },
    loadData: async function () {
      this.userInfo = localStorage.getItem('userInfo')
      let cid = localStorage.getItem('cid') // （注：从localstorage取出cid）
      if (!this.userInfo) {
        cid = null
      }
      this.navItems = ['All']
      const url = 'innovation/home/get/promotions'
      const visitorCode = await LogUtils.getVisitorCode()
      let param = 'local=' + (localStorage.getItem('locale') || 'EN') + '&client=app&campaignId=' + cid + '&visitorCode=' + visitorCode
      if (this.userInfo) {
        param += '&userId=' + JSON.parse(this.userInfo).UserId
      }
      let fullUrl = url + '?' + param
      request('get', fullUrl).then(res => {
        if (res.Result != null) {
          let promotionResList = res.Result
          // 完成首充之后不再显示
          if (this.$store.state.userFirstDeposit === false) {
            promotionResList = promotionResList.filter(i => i.KeyText !== 'firstDeposit')
          }
          // 非召回用户不显示
          if (this.$store.state.callbackTimeSpan <= 0) {
            promotionResList = promotionResList.filter(i => i.KeyText !== 'callback')
          }
          if (!this.$store.state.newUserIsShowIcon && this.userInfo) {
            promotionResList = promotionResList.filter(i => i.Url !== '/NewcomerSignIn')
          }
          this.promotionList = []
          let promotion
          setTimeout(() => {
            promotionResList.forEach(item => {
              if (item.Url === '/NewcomerSignIn') {
                promotion = {
                  id: item.Id,
                  startUpPopup: item.SequenceNo,
                  name: item.Name,
                  category: item.Category.split(','),
                  key: item.KeyText,
                  path: item.Url,
                  type: item.PromotionType,
                  introduceImg: item.Cover,
                  IsHot: item.IsHot,
                  RedDot: this.$store.state.giftShowRedCircle,
                  BeginTime: item.BeginTime,
                  ExpirationTime: item.ExpirationTime,
                  ShowTimeSpan: item.ShowTimeSpan
                }
              } else {
                promotion = {
                  id: item.Id,
                  startUpPopup: item.SequenceNo,
                  name: item.Name,
                  category: item.Category.split(','),
                  key: item.KeyText,
                  path: item.Url,
                  type: item.PromotionType,
                  introduceImg: item.Cover,
                  IsHot: item.IsHot,
                  RedDot: item.RedDot,
                  BeginTime: item.BeginTime,
                  ExpirationTime: item.ExpirationTime,
                  ShowTimeSpan: item.ShowTimeSpan
                }
              }
              let that = this
              promotion.category.forEach((category) => {
                if (!that.navItems.includes(category)) {
                  that.navItems.push(category)
                }
              })
              if (this.$store.state.depositActivityIcon === true) {
                this.promotionList.push(promotion)
                // 参与充值活动的新用户才显示跳转到DepositAndWin的promotion
              } else if (!promotion.path || promotion.path.toLowerCase() !== '/depositandwin') {
                this.promotionList.push(promotion)
              }
            })
          })

          setTimeout(() => {
            this.initSwiper()
            this.chooseNavItem('All', 0, true)
          }, 0)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    initSwiper () {
      if (!this.swiper) {
        let that = this
        const w = window.innerWidth * 0.0002
        this.swiper = new Swiper('.nav-wrapper', {
          direction: 'horizontal', // 滑动方向，可设置水平(horizontal)或垂直(vertical)。
          loop: false, // 设置为true 则开启loop模式
          autoplay: false, // 自动切换时间
          slidesPerView: 'auto', // 设置slider容器能够同时显示的slides数量(carousel模式)。类型：number or auto
          centeredSlides: false, // 设定为true时，active slide会居中，而不是默认状态下的居左。
          spaceBetween: w, // 在slide之间设置距离（单位px）。
          initialSlide: that.swiperIndex,
          loopAdditionaSlider: 1, // loop模式下会在slides前后复制若干个slide,，前后复制的个数不会大于原总个数。
          navigation: { // 左右按钮
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          on: {
            slideChange: function (e) {
              // that.showType = that.topList[that.swiperIndex].value
              // that.selectType(that.showType)
            }
          }
        })
        that.swiperIndex = this.swiper.activeIndex
      }
    },
    gotoRoute: function (path, key, type, id) {
      switch (type) {
        case 1:
          if (key) {
            this.$router.push({path: path, query: {key}})
          } else {
            this.$router.push(path)
          }
          break
        case 2:
          path = 'PromotionRule'
          this.$router.push({path: path, query: {key}})
          break
        case 3:
          const user = localStorage.getItem('userInfo')
          if (user) {
            this.iFrameSrc = path
            this.showTournament = true
          } else {
            this.$router.push('/Login')
          }
          break
        case 4:
          path = 'PromotionGame'
          let param = {}
          param.id = id
          param.key = key
          this.$router.push({path: path, query: param})
          break
      }
    },
    handleCloseIFrame3Part () {
      this.showTournament = false
    }
  },
  beforeDestroy () {
    if (this.swiper) {
      this.swiper.destroy()
    }
  }
}
</script>

<style lang="less" scoped>
.promotionPage {
  padding: 56px 0 70px 0;
  background: rgb(59,59,59);
  width: 100vw;
  height: 100%;
  overflow: hidden;
  .nav-wrapper {
    position: relative;
    left: 50%;
    transform: translate(-50%);
    width: 100%;
    background: #212324;
    //border-radius: 1.944vw;
    height: 10.8055vw;
    display: flex;
    justify-content: flex-start;
    overflow: hidden;
    padding-left: 8vw;
    padding-right: 1.5vw;
    .arrow {
      position: absolute;
      top: 0;
      width: 8vw;
      height: 10.8055vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .swiper-button-next {
      background: #212324;
      right: 0;
      //box-shadow: -1.5vw 0 0.5vw 0 rgba(15, 15, 15, 0.3);

      img {
        width: 1.3638vw;
        height: 2.5vw;
      }
    }

    .swiper-button-prev {
      background: #0F0F0F;
      left: 0;
      box-shadow: 1.5vw 0 0.5vw 0 rgba(15, 15, 15, 0.3);

      img {
        width: 1.3638vw;
        height: 2.5vw;
      }
    }

    .swiper-wrapper {
      display: flex;
      justify-content: space-around;
      width: 100%;
      margin: auto;
      height: 10.8055vw;
    }

    .nav {
      width: max-content;
      height: 10.8055vw;
      padding: 1.2861vw 0;

      .nav-item {
        width: max-content;
        height: 8.2333vw;
        line-height: 8.2333vw;
        text-align: center;
        border-radius: 1.9444vw;
        color: #4B4B4B;

        span {
          margin: 0 3.68vw;
        }
      }

      .active {
        background: #242424;
        color: #F6D9AA;
        border-radius: 1.944vw;
      }
    }

    .swiper-button-prev::after {
      display: none;
    }

    .swiper-button-next::after {
      display: none;
    }

    .swiper-button-disabled {
      display: none;
    }

    .swiper-slide {
      height: 10.8055vw;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .redDot{
        height: 2.5vw;
        width: 2.5vw;
        background: #F23042;
        position: absolute;
        border-radius: 100vw;
        right: 0.5vw;
        top: 2vw;
      }
      .indicator{
        height: 5vw;
        width: 5vw;
        background: rgb(59,59,59);
        position: absolute;
        transform: rotate(136deg);
        top: 9.9vw;
      }
    }

    .swiper-slide-active {
    }
  }
  .promotionsBox{
    display: flex;
    //align-items: center;
    position: relative;
    .indicator{
      position: absolute;
      left: 0;
      //top: 4vw;
      height: 6.4vw;
      width: 0.933vw;
      background-color: #F6D9AA;
      z-index: 9;
      transition: all 0.2s ease-in-out;
    }
    .leftBarIN{
      //height: calc(100vh - 10.855vw - 56px);
      width: 23.333vw;
      //border: 1px solid red;
      background-color: #161819;
      border-radius: 0 5px 5px 0; // 父容器右上角圆角
      position: relative;
      z-index: 3;
      top: 3.7vw;
      display: flex;
      flex-direction: column;
      gap: 5vw;
      padding-bottom: 28vh;
      .item{
        width: 23.333vw;
        flex: 1;
        //border: 1px solid red;
        text-align: center;
        //line-height: 10.833vw;
        white-space: normal;
        overflow-wrap: break-word;
        font-size: 3.888vw;
        //padding: 3.833vw;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #575757;
        z-index: 0;
        padding: 0.2vw;
      }
      .itemed{
        width: 23.333vw;
        flex: 1;
        //border: 1px solid red;
        text-align: center;
        //line-height: 10.833vw;
        white-space: normal;
        overflow-wrap: break-word;
        font-size: 3.888vw;
        //padding: 3.833vw;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #3b3b3b;
        color: #fff;
        position: relative;
      }
      .itemed::before {
        content: '';
        position: absolute;
        left: 0;
        top: 18%;
        bottom: 18%;
        width: 0.8vw;
        background-color: #F6D9AA;
      }
    }
    .leftBar{
      //height: calc(100vh - 10.855 - 56px);
      width: 23.333vw;
      //border: 1px solid red;
      background-color: #161819;
      border-radius: 0 5px 5px 0; // 父容器右上角圆角
      position: relative;
      z-index: 3;
      top: 3.7vw;
      display: flex;
      flex-direction: column;
      gap: 5vw;
      padding-bottom: 28vh;
      .item{
        width: 23.333vw;
        flex: 1;
        //border: 1px solid red;
        text-align: center;
        //line-height: 10.833vw;
        white-space: normal;
        overflow-wrap: break-word;
        font-size: 3.888vw;
        //padding: 3.833vw;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #575757;
        z-index: 1;
        padding: 0 0.4vw;
      }
      .itemed{
        width: 23.333vw;
        flex: 1;
        //border: 1px solid red;
        text-align: center;
        //line-height: 10.833vw;
        white-space: normal;
        overflow-wrap: break-word;
        font-size: 3.888vw;
        //padding: 3.833vw;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #3b3b3b;
        color: #fff;
        position: relative;
        padding: 0 0.4vw;
        z-index: 1;
      }
      .itemed::before {
        content: '';
        position: absolute;
        left: 0;
        top: 18%;
        bottom: 18%;
        width: 0.8vw;
        background-color: #F6D9AA;
      }
    }
    .promotions {
      height: calc(100vh - 136px - 14.8055vw);
      flex: 1;
      //margin-left: 2.777vw;
      overflow-x: hidden;
      overflow-y: auto;
      text-align: center;
      margin-top: 4vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1.5vw;
      .noContent{
        position: absolute;
        left: 45%;
        top: 30%;
        font-size: 5vw;
      }
      .promotionImage {
        width: 71.111vw;
        height: 35.244vw;
        //margin: 0 auto 5.6472vw auto;
        border-radius: 1.666vw;
        //overflow: hidden;
        flex-shrink: 0;
        margin-top: 1vw;
        position: relative;
        img{
          border-radius: 1.666vw;
        }
        .isHot{
          width: 11.944vw;
          height: 4.444vw;
          background-color: #9E0000;
          color: #ECECEC;
          border-radius: 1.111vw;
          position: absolute;
          text-align: center;
          line-height: 4.444vw;
          font-family: 'Inter';
          font-style: normal;
          font-weight: 600;
          font-size: 3.055vw;
          position: absolute;
          top: 2vw;
          left: 2vw;
        }
        .isRedDot{
          height: 2.5vw;
          width: 2.5vw;
          background: #F23042;
          position: absolute;
          border-radius: 10vw;
          top: -0.5vw;
          right: -0.5vw;
        }
        .BeginTime{
          position: absolute;
          bottom: 0;
          height: 5vw;
          width: 100%;
          background-color: rgba(0,0,0,0.9);
          color: #737373;
          text-align: left;
          font-size: 2.7vw;
          padding-left: 2vw;
          display: flex;
          align-items: center;
          .clock{
            height: 3.5vw;
            width: 3.021vw;
            //padding-right: 0.7vw;
          }
          .time{
            margin-left: 1vw;
            margin-top: 0.2vw;
          }
        }
      }

      .introduceImg {
        width: 100%;
        height: 100%;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Promotion/index.vue